const GOOGLE_MAPS_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? '';

let loaded = false;
let loading = false;
const callbacks: (() => void)[] = [];

export function getGoogleMapsKey(): string {
  return GOOGLE_MAPS_KEY;
}

export function loadGoogleMaps(): Promise<void> {
  if (loaded || (window as any).google?.maps) {
    loaded = true;
    return Promise.resolve();
  }
  if (!GOOGLE_MAPS_KEY) return Promise.reject('No API key');

  return new Promise((resolve, reject) => {
    if (loading) {
      callbacks.push(resolve);
      return;
    }
    loading = true;

    // Check if script tag already exists
    if (document.querySelector('script[src*="maps.googleapis.com"]')) {
      const check = setInterval(() => {
        if ((window as any).google?.maps) {
          clearInterval(check);
          loaded = true;
          loading = false;
          resolve();
          callbacks.forEach(cb => cb());
          callbacks.length = 0;
        }
      }, 50);
      return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_KEY}&libraries=places`;
    script.async = true;
    script.onload = () => {
      loaded = true;
      loading = false;
      resolve();
      callbacks.forEach(cb => cb());
      callbacks.length = 0;
    };
    script.onerror = () => {
      loading = false;
      reject('Failed to load Google Maps');
    };
    document.head.appendChild(script);
  });
}
